export default (newPaymentFormData) => ({
  registrationNumber: newPaymentFormData?.registrationNumber,
  country: newPaymentFormData?.country,
  city: newPaymentFormData?.city,
  postCode: newPaymentFormData?.postCode,
  state: newPaymentFormData?.state,
  address: newPaymentFormData?.address
});
